import React, { useState, useEffect } from 'react';
import { MainContainer } from './template/MainContainer';
import { Logo } from './template/Logo';
import { Link } from 'react-router-dom';
import './Home.css';
import { useAuth } from '../context/AuthContext';
import { fetchData } from '../utils/datasource';
import Preloader from './template/Preloader';

const Menu = ({ label, disabled, link }) => {
  return (
    <div className="col-md-6 mb-3 d-flex">
      <Link to={link} className="btn shadow-sm flex-fill themeTextColorPrimary fw-bold custom-font-size btn-click-effect" aria-disabled={disabled}>
        {label}
      </Link>
    </div >
  );
};

function Home() {
  const { user } = useAuth();
  const userId = user?.id || 'Usuário não encontrado';
  const [userPermissions, setUserPermissions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserPermissions = async () => {
      try {
        setLoading(true);
        const response = await fetchData(
          `/sibeapp/getuser?codusr=${userId}`,
          'GET',
          {},
          30000
        );

        if (!response.ok) {
          throw new Error('Failed to fetch user permissions');
        }

        const result = await response.json();

        if (result.status !== 'ok' || !result.data || result.data.length === 0) {
          throw new Error('Invalid response or no user data');
        }

        setUserPermissions(result.data[0]);
        setError(null);
      } catch (err) {
        console.error('Error fetching user permissions:', err);
        setError('Erro ao buscar permissões do usuário.');
        // Set default permissions (hide all menus) in case of error
        setUserPermissions({
          VAI_XLBVDA: '',
          VAI_XLBPCM: '',
          VAI_XLBPVD: '',
          VAI_XLBPAG: ''
        });

      } finally {
        setLoading(false);
      }
    };

    console.log(user.userName)



    if (userId && userId !== 'Usuário não encontrado') {
      fetchUserPermissions();
    } else {
      setLoading(false);
    }
  }, [userId]);

  if (loading) {
    return <Preloader />;
  }

  return (

    <MainContainer showHeader={false}>
      <Logo showLogout />

      <div className="container p-4">
        {error && (
          <div className="alert alert-warning" role="alert">
            {error}
          </div>
        )}

        <div className="row ">
          {userPermissions?.VAI_XLBVDA === '1' && (
            <Menu label={"APROVAÇÃO DESCONTO OS/ORC."} link={"/aprovacao_desconto_os_orcamento"} />
          )}
          {userPermissions?.VAI_XLBPCM === '1' && (
            <Menu label={"APROVAÇÃO PEDIDO COMPRA"} link={"/aprovacao_pedido_compra"} />
          )}
          {userPermissions?.VAI_XLBPVD === '1' && (
            <Menu label={"LIBERA PRÓXIMA VENDA"} link={"/libera_proxima_venda"} />
          )}
          {userPermissions?.VAI_XLBPAG === '1' && (
            <Menu label={"LIBERAÇÕES FINANCEIRAS"} link={"/liberacoes_financeiras"} />
          )}
        </div>
      </div>
    </MainContainer>
  )
}

export default Home;